class Profile {
  constructor(phoneNumber, id, emailAddress, address, birthDate) {
    this.phoneNumber = phoneNumber;
    this.id = id;
    this.emailAddress = emailAddress;
    this.address = address;
    this.birthDate = birthDate;
  }
}

export default {
  Profile,
};
